import { render } from "./ViewResolutionRow.vue?vue&type=template&id=1445a69b&scoped=true"
import script from "./ViewResolutionRow.vue?vue&type=script&lang=js"
export * from "./ViewResolutionRow.vue?vue&type=script&lang=js"

import "./ViewResolutionRow.vue?vue&type=style&index=0&id=1445a69b&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-1445a69b"

export default script